import type { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import type { IDialogContentComponent } from '../../modal-dialog/modal-dialog.service';

@Component({
  selector: 'app-confirm-popup',
  templateUrl: './confirm-popup.component.html',
  styleUrls: ['./confirm-popup.component.scss']
})
export class ConfirmPopupComponent implements OnInit, IDialogContentComponent<boolean, undefined> {
  input?: undefined  ;

  ngOnInit(): void {}

  getResult(): boolean {
    return true;
  }

  isDisabled(): boolean {
    return false;
  }
}
